import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { itemSelector: { type: String, default: '.archive-item' } }

  submit (event) {
    if (this.animated) return

    const selectedItems = this.findSelectedItems()
    if (selectedItems.length === 0) return

    event.preventDefault()
    this.animateOut(selectedItems).then(() => {
      this.animated = true
      this.element.requestSubmit()
    })
  }

  findSelectedItems () {
    const checked = this.element.querySelectorAll('input[type="checkbox"]:checked')
    const items = []
    checked.forEach((c) => {
      if (c.value === '' || c.dataset.checkboxAll === 'true') return
      const item = c.closest(this.itemSelectorValue) || c.closest('label')
      if (item && !items.includes(item)) items.push(item)
    })
    return items
  }

  animateOut (items) {
    return new Promise((resolve) => {
      items.forEach((el, i) => {
        el.style.transition = 'opacity 250ms ease-out, transform 250ms ease-out'
        el.style.transitionDelay = `${i * 40}ms`
        requestAnimationFrame(() => {
          el.style.opacity = '0'
          el.style.transform = 'translateY(-12px)'
        })
      })
      const totalDuration = 250 + items.length * 40
      setTimeout(resolve, totalDuration)
    })
  }
}
